import { useState } from 'react'
import { Skeleton, Layout, Modal, Input, message } from 'antd'
import './index.css'
import req from '../request'


const App = props => {
    const [uname, setUname] = useState(null)
    const [upass, setUpass] = useState(null)

    const { Header, Content } = Layout

    const login = () => {
        const dt = { uname: uname, upass: upass, action: 'userlogin' }
        // console.log(dt);
        req.login(dt).then(r => {
            console.log(r)
            if (r.status === 'done') {
                message.success('登陆成功')
                req.setToken(r.token)
                setTimeout(() => window.history.go(0), 1000)
            } else if (r.status === 'forceOffline') {
                message.error(r.msg, 10)
            } else {
                message.error(r.msg)
            }
        })

    }
    return <Layout>
        <Header className="header"><div style={{ width: '100%' }}><Skeleton /></div></Header>
        <Layout>
            <Content className='content'><div style={{ padding: '10px' }}><Skeleton /><Skeleton /><Skeleton /><Skeleton /></div></Content>

        </Layout>
        <Modal
            className='loginModal'
            title="系统登陆"
            visible={true}
            closable={false}
            width={300}
            onOk={login}
            // onCancel={this.hideModal}
            okText="登陆"
        // cancelText="取消"
        >

            <Input onChange={e => setUname(e.target.value)} placeholder="用户名 / 手机 / 邮箱" />
            <p></p>

            <Input.Password onChange={e => setUpass(e.target.value)} placeholder="密码" />
            <p></p>
        </Modal>
    </Layout>
}

export default App